import { postJsonAsync } from './fetchConfig';

export type AddManualHighRiskData = { comments: string, acceptanceDateFrom: string, acceptanceDateTo: string, reviewers: any };
type AddManualHighRiskResponse = { id: string };

export const addManualHighRiskForFleet = (fleetId: string, manualHighRiskData: AddManualHighRiskData) =>
  postJsonAsync<AddManualHighRiskResponse, AddManualHighRiskData>(
    `fleets/${fleetId}/manual-high-risks`, manualHighRiskData);
